import { postRequest } from 'utils/api/apiRequest'

export const postRecentlyViewedProduct = (product: number) =>
  postRequest('/redemption-site/recently-viewed', { product })
